<template>
  <div class="grid-layout-video">
    <div
      class="video-album"
      v-for="video in videos"
      :key="video.id"
      @click="navigateToPlay(video)"
    >
      <div class="cover">
        <img :src="video.firstFrame" alt="" />
        <p>{{ video.duration | secondToDatetime }}</p>
      </div>
      <p class="title">{{ video.name }}</p>
    </div>
  </div>
</template>

<script>
import { secondToDatetime } from "@/utils/time";

export default {
  name: "GridLayoutVideo",
  props: {
    videos: {
      type: Array,
      required: true,
      default: () => []
    }
  },
  filters: {
    secondToDatetime
  },
  methods: {
    navigateToPlay(video) {
      this.$router.push({
        name: "videoPlay",
        params: { id: video.id, video: video }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.grid-layout-video {
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-template-rows: auto;
  grid-gap: 10px;
  .video-album {
    width: 100%;
    .cover {
      position: relative;
      width: 100%;
      height: 112px;
      border-radius: 6px;
      background: #e4e4e4;
      border: none;
      overflow: hidden;
      img {
        width: 100%;
        height: 100%;
      }
      p {
        position: absolute;
        bottom: 5px;
        right: 10px;
        font-size: 12px;
        font-weight: 400;
        color: rgba(255, 255, 255, 1);
        line-height: 14px;
      }
    }
    .title {
      margin-top: 10px;
      /*
        TODO:
          gird布局中的cell，宽度不固定，是响应式的，
          当文字使用 white-space: nowrap不换行，
          文本的宽度会顶破gird cell自适应的宽度
        */
      width: 168px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      text-align: left;
      font-size: 15px;
      font-weight: 400;
      color: rgba(51, 51, 51, 1);
      line-height: 21px;
    }
    @media screen and (max-width: 320px) {
      .title {
        width: 140px;
      }
    }
  }
}
</style>
